var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.333252,
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F0FDF4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.1735 29.5348L30.9583 34.75L29.1805 32.9723M32.3333 21C26.2581 21 21.3333 25.9249 21.3333 32C21.3333 38.0751 26.2581 43 32.3333 43C38.4084 43 43.3333 38.0751 43.3333 32C43.3333 25.9249 38.4084 21 32.3333 21Z",
    stroke: "#25C277",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBalance);
export default __webpack_public_path__ + "static/media/Balance.86b201538d3089e0396d0964be9a6b97.svg";
export { ForwardRef as ReactComponent };